import React from 'react';
// import Icon from '../Icon/AppIcon';
import '../Css_files/View.css';
import Icon1 from './AppIcon';

const ViewToggle = ({ viewMode, onViewModeChange }) => {
  return (
    <div className="view-toggle">
      <button
        onClick={() => onViewModeChange('grid')}
        className={`view-button ${viewMode === 'grid' ? 'active' : ''}`}
      >
        <Icon1 name="Grid3X3" size={16} />
        Grid
      </button>
      <button
        onClick={() => onViewModeChange('list')}
        className={`view-button ${viewMode === 'list' ? 'active' : ''}`}
      >
        <Icon1 name="List" size={16} />
        List
      </button>
    </div>
  );
};

export default ViewToggle;